module.exports = __webpack_public_path__ + "static/media/depositar-azul.7613c81e.svg";